module.exports = {
      id: "filter-icon-usage",
      viewBox: "0 0 13 14",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#filter-icon",
      toString: function () {
        return this.url;
      }
    }